(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mtt-cup-status"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';
  function stateFor(data, variantId, quantity) {
    if (Number(data.productId) !== 8377503154440) return null;
    const variant = data.variants.find(v => String(v.id) === String(variantId));
    if (!variant || !Number.isInteger(quantity) || quantity < 1) return null;
    const known = variant.tracked === true && Number.isInteger(variant.stock);
    return {
      variant,
      known,
      preorder: !known || variant.stock < quantity,
      seconds: Number(data.productId) === 8377503154440 && /^Wach in/.test(variant.motif)
    };
  }
  function validSeconds(value) {
    return /^[0-9]{1,3}([.,][0-9]{1,3})?$/.test(value.trim()) && Number(value.trim().replace(',', '.')) > 0;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { stateFor, validSeconds };
  if (typeof customElements === 'undefined' || customElements.get('mtt-thermo-status')) return;
  customElements.define('mtt-thermo-status', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.data = JSON.parse(this.querySelector('[data-thermo-state]').textContent);
      this.scope = this.closest('.shopify-section') || document.body;
      if (!this.scope) return;
      this.scope.classList.add('mtt-thermo-scope');
      this.form = document.getElementById('BuyButtons-ProductForm-' + this.dataset.section);
      if (!this.form) return;
      this.seconds = this.querySelector('[data-thermo-seconds-input]');
      this.changed = () => this.update();
      this.checkedSubmit = event => {
        this.update();
        if (this.current?.seconds && !validSeconds(this.seconds.value)) {
          event.preventDefault(); event.stopImmediatePropagation();
          this.seconds.setCustomValidity(this.data.labels.secondsError);
          this.seconds.reportValidity(); this.seconds.focus();
        } else if (!this.current) {
          event.preventDefault(); event.stopImmediatePropagation();
        }
      };
      this.scope.addEventListener('change', this.changed);
      this.scope.addEventListener('input', this.changed);
      this.form.addEventListener('submit', this.checkedSubmit, true);
      this.onDocumentClick = event => {
        if (event.target.closest('#mtt-satc-btn') && this.current?.seconds && !validSeconds(this.seconds.value)) {
          event.preventDefault(); event.stopImmediatePropagation();
          this.seconds.setCustomValidity(this.data.labels.secondsError);
          this.seconds.reportValidity(); this.seconds.focus();
        }
      };
      document.addEventListener('click', this.onDocumentClick, true);
      /* Horizon (10.10.2026): Variantenwechsel über das productSelect-Ereignis des Abschnitts */
      this.onSelect = event => {
        if (!event.promise) return;
        event.promise.then(({ detail }) => {
          const fresh = detail?.html?.querySelector('mtt-thermo-status [data-thermo-state]');
          if (fresh) this.data = JSON.parse(fresh.textContent);
          setTimeout(() => this.update(), 80);
        }).catch(() => {});
      };
      this.scope.addEventListener('shopify:product:select', this.onSelect);
      this.scope.addEventListener('product:select', this.onSelect);
      this.update();
    }
    update() {
      const variantId = this.form.querySelector('[name="id"]')?.value;
      const quantity = Number(this.scope.querySelector('[name="quantity"]')?.value || 1);
      this.current = stateFor(this.data, variantId, quantity);
      const current = this.current;
      const labels = this.data.labels;
      this.scope.classList.toggle('mtt-thermo-preorder', !current || current.preorder);
      this.scope.classList.toggle('mtt-thermo-personalized', !!current?.seconds);
      const combination = document.querySelector('[id$="__fbt_combo"]');
      if (combination) combination.hidden = !!current && current.variant.motif !== 'Ohne Aufdruck';
      const text = !current || !current.known ? labels.unknown : current.preorder ? labels.preorder : labels.available;
      this.querySelector('[data-thermo-label]').textContent = text;
      this.querySelector('[data-thermo-motif]').value = current?.variant.motif || '';
      const delivery = this.querySelector('[data-thermo-delivery]');
      delivery.disabled = !current?.preorder;
      delivery.value = text;
      if (this.seconds) {
        this.querySelector('[data-thermo-seconds]').hidden = !current?.seconds;
        this.seconds.disabled = !current?.seconds;
        this.seconds.required = !!current?.seconds;
        this.seconds.setCustomValidity('');
      }
      if (current) {
        const button = this.scope.querySelector('product-form-component [ref="addToCartButton"] .add-to-cart-text__content > span:first-child');
        if (button) button.textContent = current.preorder ? labels.preorderButton : labels.addButton;
      }
    }
    disconnectedCallback() {
      this.scope?.removeEventListener('shopify:product:select', this.onSelect);
      this.scope?.removeEventListener('product:select', this.onSelect);
      this.scope?.removeEventListener('change', this.changed);
      this.scope?.removeEventListener('input', this.changed);
      this.form?.removeEventListener('submit', this.checkedSubmit, true);
      document.removeEventListener('click', this.onDocumentClick, true);
      this.started = false;
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
